import script from "./TablaMovimientos.vue?vue&type=script&setup=true&lang=js"
export * from "./TablaMovimientos.vue?vue&type=script&setup=true&lang=js"

import "./TablaMovimientos.vue?vue&type=style&index=0&id=ce2f8ffc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce2f8ffc"]])

export default __exports__